import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

const PerforatedSheet = () => {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();
  const [folderName, setFolderName] = useState("default");
  const [stepUrl, setStepUrl] = useState("");
  const [glbUrl, setGlbUrl] = useState("");
  const [inputs, setInputs] = useState({
    L: 200,
    W: 120,
    t: 1.5,
    margin: 5,
    pitch_x: 10,
    pitch_y: 10,
    pattern: "square",
    hole_type: "round",
    hole_d: 5,
    slot_len: 12,
    slot_w: 4,
    slot_angle: 0,
    oversize: 0,
    chamfer: 0.1,
  });

  // Redirect if not signed in
  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  // Inject model-viewer script
  useEffect(() => {
    if (!document.querySelector("script#model-viewer")) {
      const script = document.createElement("script");
      script.id = "model-viewer";
      script.type = "module";
      script.src =
        "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
      document.head.appendChild(script);
    }
  }, []);

  // Fetch folder name
  useEffect(() => {
    const fetchFolderName = async () => {
      try {
        const response = await fetch("https://www.d-rosa.ai/appname");
        const data = await response.json();
        setFolderName(data.foldername || "default");
      } catch (error) {
        console.error("Error fetching folder name:", error);
      }
    };
    fetchFolderName();
  }, []);

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  // Submit to create perforated sheet
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://www.d-rosa.ai/perforatedsheet", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
          params: inputs,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setStepUrl(data.stepurl || "");
        alert("Perforated Sheet created successfully!");
      } else {
        console.error("Error creating sheet");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  const handleView = async () => {
    try {
      const response = await fetch("https://www.d-rosa.ai/perforatedsheettoglbb", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setGlbUrl(data.glburl || "");
      } else {
        console.error("Error converting to GLB");
      }
    } catch (error) {
      console.error("Error in handleView:", error);
    }
  };

  return (
    <div id="image-container">
      <center>
        <h2 className="center-heading">Perforated Sheet Generator</h2>
      </center>

      <p>Signed in as: {userEmail}</p>

      <form onSubmit={handleSubmit}>
        {Object.keys(inputs).map((key) => (
          <div key={key} style={{ marginBottom: "10px" }}>
            <input
              type="text"
              name={key}
              value={inputs[key]}
              onChange={handleChange}
              placeholder={key}
              className="w-full p-2 border rounded"
              required
            />
          </div>
        ))}
        <button type="submit">Submit</button>
      </form>

      <br />
      <p>STEP File: {stepUrl}</p>

      {stepUrl && (
        <>
          <button onClick={handleView} style={{ padding: "10px 20px", fontSize: "16px" }}>
            View 
          </button>
          <br /><br />
          <a href={stepUrl} target="_blank" rel="noopener noreferrer">
            <button style={{ padding: "10px 20px", fontSize: "16px" }}>Download</button>
          </a>
        </>
      )}

      {glbUrl && (
        <div style={{ marginTop: "20px" }}>
          <h3>3D Model</h3>
          <model-viewer
            src={glbUrl}
            alt="Perforated sheet"
            auto-rotate
            camera-controls
            ar
            shadow-intensity="1"
            style={{ width: "600px", height: "400px", backgroundColor: "orange" }}
          ></model-viewer>
          <br />
          
        </div>
      )}

      <br />
      <button onClick={() => navigate("/previous-page")}>
        <img src={backButton} alt="Back" width="60" height="60" />
      </button>

      <footer className="footer-section">
        <div className="text-6">
          &copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default PerforatedSheet;
